import React from 'react';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import RadialSeparators from './RadialSeparator';
import { FaExclamationTriangle } from 'react-icons/fa';
import SubscriptionVoucherIcon from '../Icons/SubscriptionVoucherIcon';
import SubscriptionVoucherIconGrey from '../Icons/SubscriptionVoucherIconGrey';
import { IconContainer, LoyaltyProgressSubContainer, ProgressBarCenter } from './CircularProgressBar.styled';
import RewardSubscriptionMonthDescription from './RewardSubscriptionMonthDescription';
import { NsTypography } from '@nuskin/foundation-ui-components';
import { RewardProgressBarProps } from './types';
import { replacePlaceholders } from '../Utils/helper';

class RewardProgressBar extends React.Component<RewardProgressBarProps> {
    constructor(props: RewardProgressBarProps) {
        super(props);
    }

    render() {
        const {
            value = 0,
            voucherValue = 0,
            maxMonths = 0,
            handleOpenSubscriptionRewardPopup = () => {},
            notQualifyForRewardThisMonth = false,
            translationConfig = {
                voucherTargetAmount: '',
                monthsComplete: '',
                voucherEarned: '',
                learnMore: '',
                learn3xMore: '',
                callToAction: '',
                notQualify: '',
                approximateMonthly: '',
                approximateTotal: '',
                currentlyTrack: '',
                loyaltyLogoBlack: '',
            },
            learnMoreConfig = {
                tagLine: '',
                cardOneDescription: '',
                cardOneVoucherAmount: '',
                cardTwoDescription: '',
                cardTwoVoucherAmount: '',
                header: '',
                loyaltyLogoWhite: '',
                loyaltyBanner: '',
                learnMore: '',
            },
            currencyAbbreviate = false,
            currencyFormat = () => {},
        } = this.props;
        const voucherTargetAmount = replacePlaceholders(translationConfig.voucherTargetAmount, {
            currency_symbol: '',
            voucher_amount: '',
        });
        const voucherEarned = voucherValue
            ? currencyFormat(voucherValue, true, currencyAbbreviate)
            : currencyFormat(0, true, currencyAbbreviate);
        return (
            <LoyaltyProgressSubContainer>
                <div className="reward-progress">
                    <CircularProgressbarWithChildren
                        value={(value / maxMonths) * 100}
                        strokeWidth={12}
                        background
                        styles={buildStyles({
                            rotation: 0.5,
                            strokeLinecap: 'butt',
                            backgroundColor: (() => {
                                if (value === maxMonths && !notQualifyForRewardThisMonth) {
                                    return 'rgb(195 240 194)';
                                }
                                if (notQualifyForRewardThisMonth) {
                                    return '#fff';
                                }
                                return '#fff';
                            })(),
                            pathColor: '#6BC56A',
                            trailColor: '#E0E0E0',
                        })}
                    >
                        <RadialSeparators count={maxMonths} />
                        {(() => {
                            if (value === maxMonths && !notQualifyForRewardThisMonth) {
                                return <SubscriptionVoucherIcon />;
                            } else if (notQualifyForRewardThisMonth) {
                                return (
                                    <IconContainer>
                                        <FaExclamationTriangle className="outline-exclamation-icon" color="#91ACC8" />
                                    </IconContainer>
                                );
                            } else if (voucherValue != null || voucherValue != undefined) {
                                return (
                                    <ProgressBarCenter>
                                        <NsTypography
                                            component="div"
                                            className="center-value-progress-bar-price"
                                            variant="title-l"
                                            weight="bold"
                                        >{`${voucherEarned}`}</NsTypography>
                                        <NsTypography
                                            variant="label-s"
                                            weight="bold"
                                            component="div"
                                            className="center-value-progress-bar-voucher"
                                        >
                                            {voucherTargetAmount}
                                        </NsTypography>
                                    </ProgressBarCenter>
                                );
                            } else {
                                return (
                                    <ProgressBarCenter>
                                        <SubscriptionVoucherIconGrey />
                                    </ProgressBarCenter>
                                );
                            }
                        })()}
                    </CircularProgressbarWithChildren>
                </div>
                <RewardSubscriptionMonthDescription
                    value={value}
                    voucherValue={voucherValue}
                    notQualifyForRewardThisMonth={notQualifyForRewardThisMonth}
                    handleOpenSubscriptionRewardPopup={handleOpenSubscriptionRewardPopup}
                    maxMonths={maxMonths}
                    translationConfig={translationConfig}
                    learnMoreConfig={learnMoreConfig}
                    currencyAbbreviate={currencyAbbreviate}
                    currencyFormat={currencyFormat}
                />
            </LoyaltyProgressSubContainer>
        );
    }
}

export default RewardProgressBar;
export { RewardProgressBar };
